import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import RangeSlider from 'react-bootstrap-range-slider';
import AttributeProp from './propTypes/attributeProp';
import translate from '../../commonComponents/translate';
import { displayMoney } from '../../services/utilityFunctions';
import CustomCheckbox from '../../commonComponents/forms/inputs/CustomCheckbox';
import ArrowDown from '../../commonComponents/icons/ArrowDown';

function ShopCategoryFilter({ t, selected, attributes, onChange, priceRange }) {
  const [maxPrice, setPrice] = useState(selected.maxPrice);

  const [activeCategory, setActiveCategory] = useState(null);
  const priceRangeCategory = 'priceRange';

  const handlePriceChange = evt => {
    const value = Number(evt.target.value);
    setPrice(value);
  };
  const handleAfterPriceChange = () => onChange({ maxPrice });

  const handleAttributeChange = value => evt => {
    const isChecked = evt.target.checked;
    const attribute = selected.attributes[value.attribute]
      ? [...selected.attributes[value.attribute], value.value]
      : [value.value];
    const filtered = attribute.filter(
      v => (value.value === v && isChecked) || value.value !== v,
    );
    const attr = { ...selected.attributes };
    attr[value.attribute] = filtered;
    for (const i in attr) {
      if (!attr[i].length) {
        delete attr[i];
      }
    }
    onChange({ attributes: attr });
  };

  useEffect(() => setPrice(selected.maxPrice), [selected.maxPrice]);

  return (
    <div className="shopCategoryFilter">
      {attributes?.map(attribute =>
        !selected.category || attribute.category.includes(selected.category) ? (
          <div
            className="attributeItemGroup"
            key={`attribute-${attribute._id}`}
            onMouseOver={() => setActiveCategory(attribute._id)}
            onMouseLeave={() => setActiveCategory(null)}
          >
            <span
              className={`attributeLabel ${
                activeCategory === attribute._id ? 'active' : ''
              }`}
            >
              {attribute.name}
              <ArrowDown />
            </span>
            <div className="attributeValuesList">
              {attribute.values.map(value => (
                <CustomCheckbox
                  id={`attribute-${attribute._id}-${value}`}
                  onChange={handleAttributeChange({
                    attribute: attribute._id,
                    value,
                  })}
                  label={`${value}${attribute.unit}`}
                />
              ))}
            </div>
          </div>
        ) : null,
      )}
      <div
        className="shopCategoryFilterPriceRange"
        onMouseOver={() => setActiveCategory(priceRangeCategory)}
        onMouseLeave={() => setActiveCategory(null)}
      >
        <span
          className={`attributeLabel ${
            activeCategory === priceRangeCategory ? 'active' : ''
          }`}
        >
          <span className="maxPriceDropdownText">
            {t('shop.product.max_price')}
          </span>
          <ArrowDown />
        </span>
        <div className="attributeValuesList shopRangeSlider">
          {t('shop.product.max_price')}
          <RangeSlider
            value={maxPrice}
            max={priceRange.max}
            min={0}
            variant="primary"
            tooltip="off"
            onChange={handlePriceChange}
            onAfterChange={handleAfterPriceChange}
          />
          <div className="price-range-values">
            <span className="initial-value">{t('free')}</span>
            <span className="current-value">
              {selected.maxPrice
                ? displayMoney(maxPrice, priceRange.symbol)
                : t('free')}
            </span>
            <span className="final-value">
              {displayMoney(priceRange.max, priceRange.symbol)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

ShopCategoryFilter.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.shape(AttributeProp.propType))
    .isRequired,
  selected: PropTypes.shape({
    category: PropTypes.string.isRequired,
    maxPrice: PropTypes.number.isRequired,
    attributes: PropTypes.shape({}).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  priceRange: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
    currency: PropTypes.string,
    symbol: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
};

ShopCategoryFilter.defaultProps = {
  priceRange: PropTypes.shape({
    min: 0,
    max: 10000,
    currency: 'EUR',
    symbol: '€',
  }),
};

export default translate(ShopCategoryFilter);
